import { SessionProvider } from "next-auth/react";
import { NuqsAdapter } from "nuqs/adapters/next/pages";
import { ConfirmationProvider } from "./ConfirmationProvider";
import { ReactQueryClientProvider } from "./ReactQueryClientProvider";
import { SnackbarProvider } from "./SnackbarProvider";

export const AppProviders = ({ children, session, dehydratedState }) => {
  return (
    <SessionProvider session={session}>
      <ConfirmationProvider>
        <SnackbarProvider>
          <NuqsAdapter>
            <ReactQueryClientProvider dehydratedState={dehydratedState}>
              {children}
            </ReactQueryClientProvider>
          </NuqsAdapter>
        </SnackbarProvider>
      </ConfirmationProvider>
    </SessionProvider>
  );
};
